export const slidesData = [
  {
    id: 1,
    pageUrl: "/p-1",
    question: "מגיע סוף השבוע, \n מה הכי מתחשק לך לעשות?",
    answer1: "בינג' בNetflix",
    answer2: "יציאה לפאב",
    answer3: "טיול בטבע",
    questionNumber: "1/10",
    precentage: "10%",
    personImage: "Person3.png",
    bubbleText: "זכור! אין תשובה נכונה. בחר את מה שהכי מתאים לך",
  },
  {
    id: 2,
    pageUrl: "/p-2",
    question:
      "קבעת עם חברים להיפגש לסרט,\n ה-Waze מראה שהנסיעה תיארך שעה.\n מה הכי יתאים לך לעשות?",
    answer1: "אלך עם ה-Waze בכל מקרה",
    answer2: "אבחר במסלול שאני מכיר ויודע",
    answer3: "אבדוק מסלולים אחרים ש-Waze מציע ודרכים חלופיות באפליקציות אחרות",
    questionNumber: "2/10",
    precentage: "20%",
    personImage: "Person7.png",
    bubbleText: "אתה מתקדם\n מעולה",
  },
  {
    id: 3,
    pageUrl: "/p-3",
    question:
      "קבעת עם חברים להיפגש לסרט,\n ה-Waze מראה שהנסיעה תיארך שעה.\n מה הכי יתאים לך לעשות?",
    answer1: "אלך עם ה-Waze בכל מקרה",
    answer2: "אבחר במסלול שאני מכיר ויודע",
    answer3: "אבדוק מסלולים אחרים ש-Waze מציע ודרכים חלופיות באפליקציות אחרות",
    questionNumber: "3/10",
    precentage: "30%",
    personImage: "Person1.png",
    bubbleText: "עוד מעט\n תדע מה התחום\n המתאים לך",
  },
  {
    id: 4,
    pageUrl: "/p-4",
    question:
      "נתנו לך פרויקט ענק בלימודים שבו צריך לענות על המון שאלות, להכין מצגת וכו'. איך תהיה ההכנה לכך?",
    answer1: "אעשה הכל בעצמי בדיוק בדרך המוכרת לי",
    answer2: "אברר באינטרנט מהי הדרך הטובה ביותר בשביל כך ואסיים זאת בעצמי",
    answer3: "אקדיש לכך המון שעות ואתייעץ עם הרבה אנשים בנוגע לכך",
    questionNumber: "4/10",
    precentage: "40%",
    personImage: "Person9.png",
    bubbleText: "יופי :) \n רק עוד קצת\n ואנחנו בסוף",
  },
  {
    id: 5,
    pageUrl: "/p-5",
    question: "חבר/ה טוב/ה מינה אותך כאחראי/ת על מסיבת הרווקים/ות שלו/ה, את/ה",
    answer1: "אחקור מה בוצע במסיבות קודמות שהייתי בהן ואנסה להתאים את התכנים",
    answer2: "אבדוק מה התקציב ואארגן את הפעילויות בהתאם",
    answer3: "אעלה רעיונות למשחקים ופעילויות ואארגן הכל בעצמי",
    questionNumber: "5/10",
    precentage: "50%",
    personImage: "Person2.png",
    bubbleText: "זכור!\n אין תשובה נכונה. בחר את \n מה שהכי מתאים לך",
  },
  {
    id: 6,
    pageUrl: "/p-6",
    question: 'אתה צפוי לצאת לטיול בחו"ל עם חברים, אתה',
    answer1: "אחפש מסלול מוכן באינטרנט ואעשה התאמות",
    answer2: "אבחר אטרקציות שמתאימות לתקציב של כל החברים",
    answer3:
      "אכנס לכל הקבוצות הרלוונטיות, אשאל אנשים ואבדוק מה המסלול המעניין ביותר",
    questionNumber: "6/10",
    precentage: "60%",
    personImage: "Person6.png",
    bubbleText: "אתה מתקדם\n מעולה",
  },
  {
    id: 7,
    pageUrl: "/p-7",
    question: "גילית סוד שקשור לחבר שלך ואתה מתלבט אם לשתף אותו, אתה:",
    answer1: "אנסה לחקור ולגלות את אמיתות הדבר ואת המקור שממנו גיליתי את הסוד",
    answer2: "פשוט אלך ואספר לו ומה שיהיה יהיה",
    answer3: "אדובב אותו ואנסה לשאול אותו בעקיפין אם הוא היה מעדיף לדעת או לא",
    questionNumber: "7/10",
    precentage: "70%",
    personImage: "Person10.png",
    bubbleText: "עוד מעט\n תדע מה התחום\n המתאים לך",
  },
  {
    id: 8,
    pageUrl: "/p-8",
    question: "אתה עובר דירה ואתה בודק ספקים חדשים, איך תעשה את זה?",
    answer1:
      "אעשה השוואות מחירים בין החברות הגדולות ואקח את החברה הכי משתלמת עבורי",
    answer2: "אשאל חברים מה יותר טוב ואקח את החברה שהרוב המליץ עליה",
    answer3:
      "אשתמש בספק אחר לכל תחום ככה יעלה לי פחות כסף ויהיה קל יותר להחליף ספק בבעיה נקודתית",
    questionNumber: "8/10",
    precentage: "80%",
    personImage: "Person4.png",
    bubbleText: "יופי :) \n רק עוד קצת\n ואנחנו בסוף",
  },
  {
    id: 9,
    pageUrl: "/p-9",
    question: "אתה שוקל הסבת מקצוע, איך תבחר תחום מקצועי חדש?",
    answer1:
      "אעשה מבחני התאמה ואלך למכונים שיבחנו אותי עד שיימצא המקצוע שהכי מתאים לי",
    answer2:
      "אבדוק מה יכול להביא אותי למטרה שלי בתקופת הזמן המהירה ביותר ובהשקעה מינימלית",
    answer3:
      "אלך לפי מה שהלב שלי אומר לי, לא משנה כמה זמן ייקח העיקר שאעשה משהו שאני אוהב",
    questionNumber: "9/10",
    precentage: "90%",
    personImage: "Person5.png",
    bubbleText: "אתה מתקדם\n מעולה",
  },
  {
    id: 10,
    pageUrl: "/p-10",
    question: "באיזה תחום היית חזק יותר בתקופת התיכון?",
    answer1: "מדעים - כל מה שדרש ממני חקירה לעומק",
    answer2: "מתמטיקה ללא ספק",
    answer3: "אומנות, יצירה וכתיבה",
    questionNumber: "10/10",
    precentage: "100%",
    personImage: "Person1.png",
    bubbleText: "יופי :) \n רק עוד קצת\n ואנחנו בסוף",
  },
];
